import React from "react";
import { NumberField } from "./NumberField";

export class MoneyField extends NumberField {
    format(v: number) {
        let res = super.format(v);
        return "$" + res;
    }

    getWholeNumbersOnly(): boolean {
        return true;
    }

    getErrorText(): string {
        let error = super.getErrorText();
        if (error) {
            return error;
        }

        let val = this.getValue();
        if (val < -99999999 || val > 99999999 || (!this.props.allowZero && val == 0 && this.props.required === true))
            return `Value must be between `
                + `${this.props.allowNegative === true ? "$-99,999,999" : "$1"} and $99,999,999`
                + `${this.props.allowNegative === true ? " (excluding 0)" : ""}`;

        return null;
    }
}

export class MoneyFieldWithDecimal extends MoneyField {
    getWholeNumbersOnly(): boolean {
        return this.props.wholeNumbersOnly === true;
    }
}